import ExpertWarningIcon from './components/ExpertWarningIcon';
export default ExpertWarningIcon;
